import { render, staticRenderFns } from "./EditSettingsDialog.vue?vue&type=template&id=b38a8f8e"
import script from "./EditSettingsDialog.vue?vue&type=script&lang=js"
export * from "./EditSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditSettingsDialog.vue?vue&type=style&index=0&id=b38a8f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports